export const MARKETING_DEV_THEME_STORAGE_KEY = 'imai-marketing-dev-color';

export type MarketingColorMode = 'light' | 'dark';

/**
 * The dev console toggles the document theme (`next-themes` `.dark` on
 * `<html>`). Marketing tokens follow that class, so the switch must not
 * leave a `data-marketing-color` override behind.
 */
export function planDevThemeSwitch(current: MarketingColorMode): {
  documentTheme: MarketingColorMode;
  marketingColorAttribute: null;
} {
  return {
    documentTheme: current === 'dark' ? 'light' : 'dark',
    marketingColorAttribute: null,
  };
}
